<button (click)="treeQuickAction()" class="treeQuickActionButton ms-2">
    <span
        class="{{ iconClass }}"
        aria-hidden="true"
        style=" vertical-align: baseline;">
    </span>
</button>